import React from "react"
import {
    Card,
    CardBody
} from "reactstrap";
import { formatPrice } from "helpers/pricing";

class Contract extends React.Component {

    render() {
        
        const {
            client
        } = this.props;

        return (
            <Card>
                <CardBody>
                    <Card>
                        <CardBody>
                            <div className="typography-line">
                                <h4>
                                    <span>Project</span>
                                    {client.project?.name || "N/A"}
                                </h4>
                            </div>

                            <div className="typography-line">
                                <h4>
                                    <span>Unit Block #</span>
                                    {client.unit?.block_number || "N/A"}
                                </h4>
                            </div>

                            <div className="typography-line">
                                <h4>
                                    <span>Unit Lot #</span>
                                    {client.unit?.lot_number || "N/A"}
                                </h4>
                            </div>

                            <div className="typography-line">
                                <h4>
                                    <span>Model</span>
                                    {client.unit?.selectedModel?.name || "N/A"}
                                </h4>
                            </div>

                            <div className="typography-line">
                                <h4>
                                    <span>Model Price</span>
                                    {client.unit?.selectedModel?.price
                                        ? `PHP ${formatPrice(client.unit?.selectedModel?.price)}`
                                        : "N/A"}
                                </h4>
                            </div>
                            <div className="typography-line">
                                <h4>
                                    <span>Discount</span>
                                    {client.unit?.selectedModel?.discount
                                        ? `PHP ${formatPrice(client.unit?.selectedModel?.discount)}`
                                        : "N/A"}
                                </h4>
                            </div>
                            <div className="typography-line">
                                <h4>
                                    <span>Discount Details</span>
                                    {client.unit?.selectedModel?.discountDetails || "N/A"}
                                </h4>
                            </div>
                            <div className="typography-line">
                                <h4>
                                    <span>Net Selling Price</span>
                                    {client.unit?.selectedModel?.price
                                        ? `PHP ${formatPrice(client.unit?.selectedModel?.price - (client.unit?.selectedModel?.discount || 0))}`
                                        : "N/A"}
                                </h4>
                            </div>
                            <div className="typography-line">
                                <h4>
                                    <span>VAT</span>
                                    {client.unit?.selectedModel?.vat
                                        ? `PHP ${formatPrice(client.unit?.selectedModel?.vat)}`
                                        : "N/A"}
                                </h4>
                            </div>
                            <div className="typography-line">
                                <h4>
                                    <span>TCP</span>
                                    {client.unit?.selectedModel?.tcp
                                        ? `PHP ${formatPrice(client.unit?.selectedModel?.tcp)}`
                                        : "N/A"}
                                </h4>
                            </div>

                        </CardBody>
                    </Card>
                </CardBody>
            </Card>
        )
    }
}

export default Contract;